export const GET_CHAT_AGENTS = "GET_CHAT_AGENTS";
export const SAVE_CHAT_AGENTS = "SAVE_CHAT_AGENTS";
export const GET_CHAT_GROUPS = "GET_CHAT_GROUPS";
export const SAVE_CHAT_GROUPS = "SAVE_CHAT_GROUPS";
export const SAVE_CHAT_ASSIGNMENT_RULES = "SAVE_CHAT_ASSIGNMENT_RULES";
export const SEND_CHAT_ASSIGNMENT_RULES = "SEND_CHAT_ASSIGNMENT_RULES";
export const UPDATE_CHAT_ASSIGNMENT_RULES = "UPDATE_CHAT_ASSIGNMENT_RULES";
export const UPDATE_CHAT_ASSIGNMENT_RULE_STATUS =
   "UPDATE_CHAT_ASSIGNMENT_RULE_STATUS";
export const GET_ALL_CHAT_ASSIGNMENT_RULES = "GET_ALL_CHAT_ASSIGNMENT_RULES";
export const SAVE_ALL_CHAT_ASSIGNMENT_RULES = "SAVE_ALL_CHAT_ASSIGNMENT_RULES";
export const DELETE_CHAT_ASSIGNMENT_RULE = "DELETE_CHAT_ASSIGNMENT_RULE";
export const RESET_CHAT_ASSIGNMENT = "RESET_CHAT_ASSIGNMENT"
